import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowRight, Scan, Database, CheckCircle2 } from 'lucide-react';

const Hero = () => {
  const { t } = useLanguage();
  
  const scrollToDemo = () => {
    const demoSection = document.querySelector('.demo-section');
    if (demoSection) {
      demoSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };
  
  return (
    <section className="hero-section">
      <div className="hero-background">
        <img 
          src="https://images.unsplash.com/photo-1764115424769-ebdd2683d5a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwd29ya3Nob3AlMjByb2JvdHxlbnwwfHx8fDE3NzYwNzAwMDB8MA&ixlib=rb-4.1.0&q=85"
          alt="Industrial workshop"
          className="hero-bg-image"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <div className="hero-badge">
          <Scan size={16} />
          <span>{t('heroBadge')}</span>
        </div>
        
        <h1 className="hero-title">
          {t('heroTitle')}
        </h1>
        
        <p className="hero-subtitle">
          {t('heroSubtitle')}
        </p>
        
        <div className="hero-features">
          <div className="hero-feature">
            <Scan className="feature-icon" size={20} />
            <span>{t('heroFeature1')}</span>
          </div>
          <div className="hero-feature">
            <Database className="feature-icon" size={20} />
            <span>{t('heroFeature2')}</span>
          </div>
          <div className="hero-feature">
            <CheckCircle2 className="feature-icon" size={20} />
            <span>{t('heroFeature3')}</span>
          </div>
        </div>
        
        <button className="cta-button hero-cta" onClick={scrollToDemo}>
          <span>{t('howItWorksButton')}</span>
          <ArrowRight className="button-icon" size={20} />
        </button>
      </div>
    </section>
  );
};

export default Hero;
